import { cuartosFriosIntroImage } from "@/mocks/serviceCuartosFriosData";

export default function CuartosFriosIntro() {
  return (
    <section className="py-12 md:py-20 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="reveal">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0087a4] mb-3 block">
              Ingeniería de refrigeración
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Refrigeración diseñada para su operación
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Cada producto y proceso requiere condiciones específicas de conservación. En{" "}
              <span className="text-[#0087a4] font-semibold">SERIN</span> desarrollamos soluciones de
              refrigeración teniendo en cuenta las dimensiones del espacio, temperatura requerida, tipo
              de producto, frecuencia de uso y condiciones de operación.
            </p>

            <div className="grid grid-cols-3 gap-4">
              {[
                { value: "35+", label: "años de experiencia" },
                { value: "1,200+", label: "proyectos ejecutados" },
                { value: "100%", label: "cobertura nacional" },
              ].map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200 bg-background-50 p-4 text-center"
                >
                  <div className="text-xl md:text-2xl font-bold text-[#0087a4] font-heading mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-600 leading-snug">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="reveal relative h-[320px] md:h-[460px] rounded-lg overflow-hidden">
            <img
              src={cuartosFriosIntroImage}
              alt="Sistema de refrigeración profesional de cuarto frío con unidad evaporadora y paneles aislantes"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-4 left-4 right-4 rounded-lg bg-background-50/95 backdrop-blur-sm p-4 border border-background-200">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#0087a4] flex items-center justify-center shrink-0">
                  <i className="ri-snowy-line text-white text-lg" />
                </div>
                <p className="text-xs md:text-sm text-foreground-800 font-medium leading-snug">
                  Diseño técnico de cuartos fríos y sistemas de refrigeración para conservación y
                  congelación de productos
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}